import { gql } from 'graphql-request'

class BuzzlUserMutations {
  createBuzzlUser = gql`
    mutation CreateBuzzlUser($data: BuzzlUserCreateInput!) {
      createBuzzlUser(data: $data) {
        id
        assignedCustomers {
          name
        }
        role
        createdAt
        user {
          id
          displayName
          firstName
          lastName
          email
        }
      }
    }
  `

  deleteBuzzlUser = gql`
    mutation DeleteBuzzlUsers($where: BuzzlUsersWhereIdsInput!) {
      deleteBuzzlUsers(where: $where) {
        count
      }
    }
  `

  updateBuzzlUser = gql`
    mutation UpdateBuzzlUser($where: BuzzlUserWhereUniqueInput!, $data: BuzzlUserUpdateInput!) {
      updateBuzzlUser(where: $where, data: $data) {
        id
        assignedCustomers {
          name
        }
        role
        createdAt
        user {
          id
          displayName
          firstName
          lastName
          email
        }
      }
    }
  `
}

const buzzlUserMutations = new BuzzlUserMutations()

export default buzzlUserMutations
